module.exports = __webpack_public_path__ + "assets/img/Ram-Group-Website-w720.6b88d5b7.jpg";